import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Alert, Form, Input, Modal, Spin } from "antd";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
const ConsignmentUnassignVehicleModal = (props) => {
    const [form] = Form.useForm();
    const [stateLoading, setStateLoading] = useState(false);
    const [stateErrorMessage, setStateErrorMessage] = useState(null);
    useEffect(() => {
        if (!props.open) {
            // If we are being hidden clean field content in preparation for next use
            setStateErrorMessage(null);
            form.resetFields();
        }
    });
    const onFinish = (formValues) => {
        unassignFromVehicle(formValues.reason);
    };
    const unassignFromVehicle = (reason) => {
        setStateLoading(true);
        axios(`/admin/v1/consignments/${props.consignmentId}/assigned-vehicles/${props.assignedAction}`, {
            method: "delete",
            params: {
                reason: reason,
                consignmentVersion: props.consignmentVersion,
                assignedVehicleId: props.assignedVehicleId
            }
        }).then(response => {
            props.onUnassigned?.(response.data);
        }).catch((error) => {
            if (isConcurrentModificationError(error)) {
                setStateErrorMessage("The vehicle could not be unassigned. This is because another user has modified the same delivery.  Please refresh the delivery list and try again.");
            }
            else {
                axiosErrorHandler(error, setStateErrorMessage);
            }
        }).finally(() => {
            setStateLoading(false);
        });
    };
    return (_jsx(Modal, { title: "Unassign Delivery from Vehicle", open: props.open, onOk: form.submit, onCancel: props.onCancel, confirmLoading: stateLoading, children: _jsxs(Spin, { spinning: stateLoading, children: [_jsx(Form, { layout: "horizontal", form: form, onFinish: onFinish, children: _jsx(Form.Item, { name: "reason", label: "Reason", rules: [
                            { required: true, message: 'A reason is required' },
                            { max: 500, message: 'Please limit to 500 characters.' }
                        ], children: _jsx(Input.TextArea, { placeholder: "Reason", rows: 2 }) }) }), stateErrorMessage ?
                    _jsx(Alert, { title: stateErrorMessage, type: "error", showIcon: true }) : null] }) }));
};
export default ConsignmentUnassignVehicleModal;
